import { useState, useEffect } from 'react'

export function useWindowSize() {
	const [ width, setWidth ] = useState( 0 )
	const [ height, setHeight ] = useState( 0 )
	useEffect( () => {
		const handleResize = () => {
			setWidth( window.innerWidth )
			setHeight( window.innerHeight )
		}

		// Register initial window size (this has to be done here to prevent
		// "window is not defined" ReferenceError)
		handleResize()

		window.addEventListener( 'resize', handleResize )
		return () => window.removeEventListener( 'resize', handleResize )
	}, [] )
	return { width, height }
}
